import { GUID } from "../../helpers/guid.helper";
import { IPerson } from "./i-person";

export class Person implements IPerson {
    Id: string;
    FirstName: string;
    LastName: string;
    DocumentNumber: string;
    CUIL: string;
    Email: string;
    HighestEducationLevel: string;
    PhoneNumber: string;
    MobilePhoneNumber: string;
    AnotherContactPhone: string;
    Birtdate: Date;
    Photo: string;
    IdentificationTypeId: number;
    PersonGenderId: number;
    Manually: boolean;
    Address: string;
    IsActive: boolean;

    constructor() {
        this.Id = '-1';
        this.FirstName = '';
        this.LastName = '';
        this.DocumentNumber = '';
        this.CUIL = '';
        this.Email = '';
        this.HighestEducationLevel = '';
        this.PhoneNumber = '';
        this.MobilePhoneNumber = '';
        this.AnotherContactPhone = '';
        this.Birtdate = null;
        this.Photo = '';
        this.IdentificationTypeId = -1;
        this.PersonGenderId = -1;
        this.Address = "";
        this.IsActive = true;
    }
}


// WEBPACK FOOTER //
// ./src/app/main/models/persons/person.ts